<template>
    <span>
        {{ prefix + $t(translationKey, parameter) + suffix }}
    </span>
</template>

<script>
export default {
    name: 'Translate',
    props: {
        translationKey: String,
        parameter: Object,
        suffix: {
            type: String,
            default: '',
        },
        prefix: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped></style>
